<template>
    <div>
        <el-table :data="devices" @selection-change="changeSelection" border>
            <el-table-column align="center" type="selection" width="48" />
            <el-table-column align="center" label="设备编号" prop="deviceNo" />
            <el-table-column
                align="center"
                label="设备型号"
                prop="deviceType"
            />
            <el-table-column
                align="center"
                label="注册时间"
                prop="createTime"
            />
            <el-table-column
                align="center"
                width="150"
                label="授权通道/物理通道"
            >
                <template slot-scope="scope">
                    {{ scope.row.channel || scope.row.noFusionChannel }}/{{
                        scope.row.maxChannel
                    }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="联通状态">
                <template slot-scope="scope">{{
                    STATUS_MAP[scope.row.status]
                }}</template>
            </el-table-column>
            <el-table-column align="center" label="版本" prop="version" />
            <el-table-column align="center" label="容量/G" prop="capacity" />
            <el-table-column align="center" label="授权信息">
                <template slot-scope="scope">
                    <p :title="scope.row.comment">
                        {{ AUTH_MAP[scope.row.auth] }}{{ ' ' }}
                        {{
                            scope.row.comment.length > 15
                                ? scope.row.comment.substr(0, 15) + '...'
                                : scope.row.comment
                        }}
                    </p>
                    <p v-if="scope.row.auth == AUTH_PROBATION">
                        {{ scope.row.endTime }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="220">
                <template slot-scope="scope">
                    <el-button
                        @click="clickBind(scope.row)"
                        size="mini"
                        v-if="search.bind === TABS_UNBIND"
                        >分配给商户</el-button
                    >
                    <el-button
                        @click="clickUnbind(scope.row)"
                        size="mini"
                        v-else
                        >解除绑定</el-button
                    >
                    <el-button @click="clickAuth(scope.row)" size="mini"
                        >修改授权</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <DialogEditAuth
            :form="editForm"
            :maxChannel="maxChannel"
            :visible="editVisible"
            @on-close="changeEditVisible"
            @on-ok="handleSubmit"
        />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
    STATUS_MAP,
    AUTH_MAP,
    AUTH_PROBATION,
    TABS_UNBIND,
    DEVICE_BIND,
} from '../../../libs/enum.js';
import DialogEditAuth from '../../../components/edit-auth';

const { mapState, mapActions } = createNamespacedHelpers('agentDevice');

export default {
    components: { DialogEditAuth },
    data() {
        return {
            STATUS_MAP,
            AUTH_MAP,
            AUTH_PROBATION,
            TABS_UNBIND,
            editVisible: false,
            editForm: {},
            maxChannel: 0,
        };
    },
    computed: {
        ...mapState({
            devices: (state) => state.devices,
            search: (state) => state.search,
        }),
        agentId() {
            return this.$route.query.agentId;
        },
        agentName() {
            return this.$route.query.agentName;
        },
    },
    methods: {
        ...mapActions([
            'changeSelection',
            'changeDialog',
            'unbindDevice',
            'changeForm',
            'changeMaxChannel',
            'getDevices',
        ]),
        clickBind(data) {
            this.changeDialog({ visible: true, type: DEVICE_BIND });
            this.changeForm({
                deviceIds: data.deviceId,
                auth: data.auth,
                channel: data.channel || data.noFusionChannel,
                expireTime: data.expireTime,
                appControl: data.appControl,
                touch: data.touch,
                noFusionChannel: data.noFusionChannel === 0 ? 0 : 1,
                isH5QrCode: data.isH5QrCode,
                qrEnable: data.qrEnable,
                scene: data.scene,
                memo: data.memo,
            });
            this.changeMaxChannel(data.maxChannel);
        },
        clickUnbind(data) {
            this.$confirm(
                `是否解除设备与 ${this.agentName} 商户的绑定？`,
                '解除绑定',
                { type: 'warning' }
            )
                .then(async () => {
                    await this.unbindDevice({ deviceIds: data.deviceId });
                    this.$message.success('解除绑定成功');
                })
                .catch(() => {
                    this.$message.info('取消解除绑定');
                });
        },
        clickAuth(data) {
            this.changeEditVisible(true);
            this.editForm = {
                ...data,
                isAgent: 1,
                channel: data.channel || data.noFusionChannel,
                noFusionChannel: data.noFusionChannel === 0 ? 0 : 1,
            };
            this.maxChannel = data.maxChannel;
        },
        changeEditVisible(visible) {
            this.editVisible = visible;
            !visible ? (this.editForm = {}) : void 0;
        },
        handleSubmit() {
            this.getDevices();
        },
    },
};
</script>
